import { Breadcrumb, Carousel } from "antd";
import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;
  padding: 130px 100px 0 100px;

  .layout-view {
    padding: 100px 150px 0 150px;

    @media only screen and (max-width: 915px) {
      padding: 100px 50px 0 50px;

      .ant-row {
        flex-direction: column-reverse;
      }

      .ant-row.row-view {
        flex-direction: column;
      }

      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-17 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0 !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  .ant-carousel {
    width: 100%;
  }

  .row-section {
    display: flex;
  }

  .row-branch {
    margin-top: 10%;

    @media only screen and (max-width: 1024px) and (orientation: portrait) {
      p {
        line-height: 35px;
      }
    }
  }

  .row-branch-contact {
    margin-top: 10%;

    @media only screen and (max-width: 1024px) and (orientation: portrait) {
      p {
        line-height: 35px;
      }
    }
  }

  @media screen and (max-width: 414px) {
    .row-branch-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-15 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    .row-branch-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
      .ant-col-15 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .row-branch-contact {
      margin-left: 0;

      .ant-col-8 {
        flex: 0 0 100%;
        max-width: 100%;
      }
      .ant-col-15 {
        flex: 0 0 100%;
        max-width: 100%;
      }

      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  .row-contact {
    margin-left: 30px;
    margin-top: 80px;
  }

  @media only screen and (min-width: 1440px) {
    .col-left-section {
      margin-left: 38px;
    }
  }

  @media only screen and (max-width: 414px) {
    padding: 130px 25px 0 25px !important;

    .row-section {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      p {
        line-height: 30px;
      }
    }

    .row-contact {
      margin-left: 0;

      .ant-col-6 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-9 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }

    .row-structure {
      .ant-col-8 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .row-contact {
      margin-left: 0;

      .ant-col-6 {
        flex: 0 0 100%;
        max-width: 100%;
      }
      .ant-col-9 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }
  }

  @media only screen and (max-width: 912px) {
    padding: 150px 80px 0 80px;

    .row-structure {
      .ant-col-8 {
        flex: 0 0 50%;
        max-width: 50%;
      }
    }

    .row-col-branch {
      .ant-col-12 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-11 {
        flex: 0 0 100% !important;
        max-width: 100% !important;
      }
      .ant-col-offset-1 {
        margin-left: 0;
      }
    }
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 150px 80px 0 80px !important;
  }
`;

export const Title = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 140px;
  font-size: clamp(36px, 2.5vw, 8px);
  text-align: left;
  margin-bottom: 0;
  padding-bottom: 0;

  @media only screen and (max-width: 912px) {
    line-height: 50px !important;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    line-height: 60px !important;
  }

  @media only screen and (max-width: 1024px) {
    line-height: 50px;
  }

  @media only screen and (min-width: 1440px) {
    line-height: 80px;
  }

  @media only screen and (min-width: 1400px) {
    font-size: 120px;
    line-height: 120px;
    margin-bottom: 15px;
  }
`;

export const TitleEN = styled.p`
  font-family: "Brevia Light Italic";
  line-height: 0;
  font-size: clamp(24px, 2.5vw, 35px);
  text-align: left;
  margin-left: 4px;
  line-height: 38px;
`;

export const TextSection = styled.p`
  color: var(--black);
  font-family: "Noto Sans Thai";
  line-height: 35px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-bottom: 20px;
  cursor: pointer;

  width: fit-content;
  position: relative;
  text-decoration: none;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: var(--secondary);
    bottom: -1px;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }

  @media only screen and (max-width: 1024px) and (orientation: portrait) {
    line-height: 35px;
  }
`;

export const TextTitle = styled.p`
  color: var(--black);
  font-family: "Noto Sans Thai Bold";
  line-height: 50px;
  font-size: clamp(36px, 2vw, 60px);
  text-align: ${(props) => (props.center ? props.center : "left")};
  margin-bottom: 25px;
  width: 100%;
  height: ${(props) => (props.height ? `${props.height}px` : "auto")};

  @media only screen and (max-width: 414px) {
    height: auto;
    font-size: 30px;
  }
`;

export const TextDetail = styled.p`
  color: var(--black);
  line-height: 40px;
  font-family: "Noto Sans Thai";
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  margin-top: ${(props) => (props.top ? `${props.top}px` : "28px")} !important;
  text-indent: ${(props) => props.indent && `${props.indent}px`};
  margin-bottom: ${(props) =>
    props.bottom ? `${props.bottom}px` : "32px"} !important;

  @media only screen and (max-width: 1024px) and (orientation: portrait) {
    line-height: 35px;
  }
`;

export const ListImage = styled.div`
  display: flex;
  width: 100%;
  font-family: "Noto Sans Thai";
  line-height: 40px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;

  p {
    font-family: "Noto Sans Thai";
    font-size: clamp(20px, 2.5vw, 24px);
    margin-top: 10px;
  }

  img {
    height: 87px;
    margin-right: 30px;
    object-fit: cover;
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
  }

  &:hover img {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  @media only screen and (max-width: 414px) {
    img {
      height: 60px;
      margin-right: 20px;
    }
  }
`;

export const Float = keyframes`
  0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-20px);
	}
	100% {
		transform: translatey(0px);
	}
`;

export const BoxImage = styled.div`
  width: 100%;
  text-align: center;

  p {
    line-height: 40px;
    font-family: "Noto Sans Thai";
    font-size: clamp(20px, 2.5vw, 24px);
    margin: 0;
    cursor: pointer;
    color: var(--black);
    position: relative;
    z-index: 1;
    width: max-content;

    &:hover {
      color: var(--white);
    }
  }

  p:before {
    transform: scaleX(0);
    transform-origin: bottom right;
  }

  p:hover::before {
    transform: scaleX(1);
    transform-origin: bottom left;
  }

  p::before {
    content: " ";
    display: block;
    position: absolute;
    top: -10px;
    right: -15px;
    bottom: 0;
    left: -15px;
    height: 54px;
    background: var(--secondary);
    border-radius: 20px;
    z-index: -1;
    transition: transform 0.3s ease;
  }

  img {
    height: 87px;
  }

  @media only screen and (max-width: 414px) {
    img {
      height: 60px;
    }
  }

  .icon-course-structure {
    overflow: hidden;
    transform: translatey(0px);
    animation: ${Float} 6s ease-in-out infinite;
    display: flex;
    justify-content: center;
  }
`;

export const CusttomBreadcrumb = styled(Breadcrumb)`
  margin-bottom: 20px;
  li {
    text-align: left;
  }
  span {
    font-family: ${(props) =>
      props.bold ? "Noto Sans Thai Bold" : "Noto Sans Thai"};
    font-size: 16px;
    text-align: left;
    line-height: 20px;
  }
`;

export const CustomCarousel = styled(Carousel)`
  img {
    border-radius: 20px !important;
    width: 100% !important;
  }

  .slick-track {
    transition: -webkit-transform 900ms linear 900ms !important;
  }

  .slick-dots {
    li {
      width: 26px !important;
      height: 26px !important;
      border-radius: 100% !important;
      background: #fff !important;
      border: 1px solid ${(props) => (props.bg ? props.bg : "var(--while)")};
      margin: 0 10px !important;
    }

    li.slick-active {
      background: ${(props) =>
        props.bg ? props.bg : "var(--while)"} !important;
    }

    @media only screen and (max-width: 414px) {
      li {
        width: 13px !important;
        height: 13px !important;
        margin: 0 5px !important;
      }
    }
  }

  .slick-dots {
    li button {
      width: 26px !important;
      height: 26px !important;
      border-radius: 100% !important;
      background: #fff !important;
      border: 1px solid ${(props) => (props.bg ? props.bg : "var(--while)")};
    }

    li.slick-active button {
      background: ${(props) =>
        props.bg ? props.bg : "var(--while)"} !important;
    }

    @media only screen and (max-width: 414px) {
      li button {
        width: 13px !important;
        height: 13px !important;
      }
    }
  }

  .slick-dots {
    z-index: 1 !important;
  }
`;

export const FixBoxLayout = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "var(--while)")};

  margin: 100px -158px 50px -158px;

  @media only screen and (max-width: 414px) {
    margin: 100px -50px 50px -50px !important;
  }

  @media only screen and (max-width: 912px) {
    margin: 100px -80px 50px -80px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    margin: 100px -80px 50px -80px !important;
  }

  @media only screen and (max-width: 1024px) {
    margin: 100px -110px 50px -110px;
  }

  .row-group {
    margin-top: 0 !important;
  }
`;

export const CardContact = styled.div`
  width: 100%;
  background-color: ${(props) =>
    props.background ? props.background : "#fff"};
  border-radius: 20px;
  margin-bottom: 35px;

  .container {
    padding-top: 0px;
    padding-right: 25px;
    padding: 50px 30px 20px 5px;
    position: absolute;
  }
`;

export const SubHead = styled.p`
  font-family: "Noto Sans Thai";
  text-align: ${(props) => (props.align ? props.align : "left")};
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 35px;
  margin-left: 30px;
  display: flex;
  margin-top: ${(props) => (props.top ? `${props.top}px` : "auto")};
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : "32px")};

  @media only screen and (min-width: 1440px) {
    min-height: ${(props) => props.height && `${props.height}px`};
  }
  ${(props) =>
    props.weight === "bold" &&
    `
     font-weight: 600;
    `}
  ${(props) =>
    props.align === "center" &&
    `
     justify-content: center;
    `}

  a {
    font-family: "Noto Sans Thai";
    text-align: left;
    font-size: clamp(20px, 2.5vw, 24px);
    line-height: 35px;
    display: flex;
    color: var(--black);
  }

  img {
    cursor: pointer;
    margin-right: 18px;
    height: 36px;
  }
`;

export const View = styled.p`
  font-family: "Noto Sans Thai";
  line-height: 140px;
  font-size: clamp(80px, 2.5vw, 96px);
  text-align: center;
  margin-bottom: 0;
  padding-bottom: 0;
  /* margin-left: 30px; */

  @media only screen and (min-width: 1400px) {
    font-size: 96px;
    line-height: 120px;
  }
`;

export const FixBox = styled.div`
  background-color: ${(props) => (props.bg ? props.bg : "var(--while)")};

  padding: 100px 158px 50px 158px;
  margin: 100px -158px 50px -158px;

  @media only screen and (max-width: 414px) {
    padding: 100px 50px 50px 50px !important;
    margin: 100px -50px 50px -50px !important;
  }

  @media only screen and (max-width: 912px) {
    padding: 100px 80px 50px 80px;
    margin: 100px -80px 50px -80px;
  }

  @media screen and (min-width: 820px) and (max-width: 1180px) and (orientation: landscape) {
    padding: 100px 80px 50px 80px !important;
    margin: 100px -80px 50px -80px !important;
  }

  @media only screen and (max-width: 1024px) {
    padding: 100px 110px 50px 110px;
    margin: 100px -110px 50px -110px;
  }

  .row-group {
    margin-top: 0 !important;
  }
`;
